import React from 'react'

import './Footer.scss';

type Props = {}

const Footer = (props: Props) => {
  return (
    <>
        <footer className="footer text-center">
            <div className="container">
                <div className="row">
                    
                    <div className="col-lg-4 mb-5 mb-lg-0">
                        <h4 className="text-uppercase mb-4">Dirección</h4>
                        <p className="lead mb-0">
                            Calle La Hoya, 2
                            <br />
                            Griegos, 44114
                            <br />
                            España
                        </p>
                    </div>
                    
                    <div className="col-lg-4 mb-5 mb-lg-0">
                        <h4 className="text-uppercase mb-4">Buscanos en...</h4>
                        <a className="btn btn-outline-light btn-social mx-1" target="_blank" rel="noreferrer" href="https://www.facebook.com/profile.php?id=100083346067021">
                            <i className="fab fa-fw fa-facebook-f"></i>
                        </a>
                        <a className="btn btn-outline-light btn-social mx-1" target="_blank" rel="noreferrer" href="https://www.instagram.com/alberguedegriegos/">
                            <i className="fab fa-brands fa-instagram"></i>
                        </a>
                    </div>
                    
                    <div className="col-lg-4">
                        <h4 className="text-uppercase mb-4">Contactanos</h4>
                        <a className="btn btn-outline-light btn-social mx-1" href="tel:+34676288072">
                            <i className="fa-solid fa-phone"></i>
                        </a>
                        <a className="btn btn-outline-light btn-social mx-1" href="mailto:reservas@alberguedegriegos.es">
                            <i className="fa-solid fa-envelope"></i>
                        </a>
                        
                    </div>
                </div>
                <div className='row'>
                    <iframe className='mapa' title='mapa' height="350" scrolling="no" src="https://www.openstreetmap.org/export/embed.html?bbox=-1.71224981546402%2C40.42366337223233%2C-1.7092564702033999%2C40.42482723762596&amp;layer=mapnik&amp;marker=40.424245307446405%2C-1.7107531428337097">
                    </iframe>
                    <br/>
                    <small>
                        <a href="https://www.openstreetmap.org/?mlat=40.42425&amp;mlon=-1.71075#map=19/40.42425/-1.71075&amp;layers=N">Ver mapa más grande</a>
                    </small>
                </div>
            </div>
        </footer>
        
        <div className="copyright py-4 text-center text-white">
            <div className="container"><small>Copyright &copy; AlbergueGriegos 2022</small></div>
        </div>
    </>
  )
}

export default Footer